export type AdsenseZoneConfig = {
  desktop: string;
  mobile: string;
};

export type AdsenseConfig = {
  enabled: boolean;
  clientId: string;
  showAwarenessToast: boolean;
  desktopLeftSidebarEnabled: boolean;
  adSlots: {
    sidebar: AdsenseZoneConfig;
    interstitial: AdsenseZoneConfig;
    belowResults: AdsenseZoneConfig;
  };
};

export const DEFAULT_ADSENSE_CONFIG: AdsenseConfig = {
  enabled: false,
  clientId: 'ca-pub-6494790779913308',
  showAwarenessToast: true,
  desktopLeftSidebarEnabled: true,
  adSlots: {
    sidebar: {
      desktop: '8515465595',
      mobile: '8515465595',
    },
    interstitial: {
      desktop: '8515465595',
      mobile: '8515465595',
    },
    belowResults: {
      desktop: '8515465595',
      mobile: '8515465595',
    },
  },
};
